import { Injectable } from '@angular/core';
import { RepositoryService } from '../baseServices/repository.service';
import { StoreName } from '../entities/StoreName';
import * as dayjs from 'dayjs';
@Injectable({
  providedIn: 'root'
})
export class MessageCenterService {

  constructor(private repository: RepositoryService) { }

  async getAll(filter: any = undefined) {
    return await this.repository.getAll(StoreName.Message, filter);
  }

  async getTodaysMessages(filter: any = undefined): Promise<any[]> {
    const messages = await this.repository.getAll(StoreName.Message, filter);
    const todaysMessages = messages.filter(record => {
      if (dayjs(record.CreatedDate).isToday()) {
        return record;
      }
    }).map(record => record);
    return todaysMessages;
  }

  async createMessage(message: any): Promise<number> {
    return await this.repository.create(message, StoreName.Message);
  }

  async updateMessage(message: any): Promise<number> {
    return await this.repository.update(message, StoreName.Message);
  }

  async deleteMessage(message: any) {
    await this.repository.delete(message, StoreName.Message);
  }
}
